import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";
import { ArtifactForm } from "./ArtifactTable";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

export const TASK_FIELDS = [
  { key: "wbsCode", label: "WBS Code", type: "text" },
  { key: "name", label: "Task Name", type: "text" },
  { key: "durationDays", label: "Duration (days)", type: "number" },
  { key: "plannedStart", label: "Planned Start", type: "date" },
  { key: "plannedFinish", label: "Planned Finish", type: "date" },
  { key: "percentComplete", label: "% Complete", type: "number" },
  { key: "status", label: "Status", type: "select", options: ["NotStarted", "InProgress", "Completed", "Blocked"] },
  { key: "owner", label: "Owner (free text)", type: "text" },
];

const PEOPLE = [["assigneeIds", "Assignees (Accountable)", true], ["ownerId", "Owner", false], ["reviewerIds", "Reviewers", true], ["approverIds", "Approvers", true]];

export function accountableFor(task, members) {
  const firstAssignee = (task.assigneeIds || [])[0];
  const m = members.find((x) => x.userId === firstAssignee) || members.find((x) => x.userId === task.ownerId);
  return m?.name || task.owner || null;
}

export default function TaskEditDialog({ projectId, task, members, open, onClose, onSaved }) {
  const [form, setForm] = useState({});
  useEffect(() => { if (task) setForm(task); }, [task]);

  const save = async () => {
    try {
      await api.patch(`/projects/${projectId}/tasks/${task.id}`, {
        ...form, durationDays: Number(form.durationDays || 1), percentComplete: Number(form.percentComplete || 0),
      });
      toast.success("Task updated — Gantt and Kanban are in sync");
      onClose();
      onSaved && onSaved();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-2xl rounded-none max-h-[85vh] overflow-auto">
        <DialogHeader><DialogTitle className="font-display">Edit Task — {task?.wbsCode} {task?.name}</DialogTitle></DialogHeader>
        <ArtifactForm fields={TASK_FIELDS} value={form} onChange={setForm} />
        <div className="grid grid-cols-2 gap-3 mt-2">
          {PEOPLE.map(([key, label, multi]) => (
            <div key={key}>
              <label className="text-xs uppercase tracking-wide font-medium">{label}</label>
              <select data-testid={`dlg-${key}`} multiple={multi} size={multi ? 3 : undefined}
                className="w-full border border-input px-2 py-1.5 text-sm bg-background mt-1"
                value={multi ? (form[key] || []) : (form[key] || "")}
                onChange={(e) => setForm({ ...form, [key]: multi ? Array.from(e.target.selectedOptions).map((o) => o.value) : e.target.value })}>
                {!multi && <option value="">— unassigned —</option>}
                {members.map((m) => <option key={m.userId} value={m.userId}>{m.name} ({m.role})</option>)}
              </select>
            </div>
          ))}
        </div>
        <Button data-testid="task-dialog-save-btn" className="rounded-none" onClick={save}>Save</Button>
      </DialogContent>
    </Dialog>
  );
}
